export var SetupStepType;
(function (SetupStepType) {
    SetupStepType["Responsibilities"] = "Functions";
    SetupStepType["Companies"] = "Companies";
    SetupStepType["Groups"] = "Groups";
    SetupStepType["Premises"] = "Premises";
    SetupStepType["Emails"] = "Emails";
    SetupStepType["Payment"] = "Payment";
    SetupStepType["Registrations"] = "Registrations";
})(SetupStepType || (SetupStepType = {}));
export function getSetupStepName(step) {
    switch (step) {
        case SetupStepType.Responsibilities:
            return $t(`%14U`);
        case SetupStepType.Companies:
            return $t(`%14V`);
        case SetupStepType.Groups:
            return $t(`%14W`);
        case SetupStepType.Premises:
            return $t(`%14X`);
        case SetupStepType.Emails:
            return $t(`%nI`);
        case SetupStepType.Payment:
            return $t(`%nJ`);
        case SetupStepType.Registrations:
            return $t(`%14Y`);
    }
}
//# sourceMappingURL=SetupStepType.js.map